import { ActivityKeys } from "web_myplann/Api/Activities/ActivityKeys";
import { limit } from "web_myplann/Api/infiniteQueryUtils";
import { useListInfiniteQuery } from "web_myplann/Api/useListInfiniteQuery";
import { getActivityV2 } from "web_myplann/Infrastructure/Api/Api";

export const useActivityListInfiniteQuery = (
	filterDatefrom?: string,
	filterDateto?: string,
	filterOnlyunsolved?: boolean,
	filterOnlysolved?: boolean,
	filterSortdesc?: boolean,
	pageSize: number = limit,
) =>
	useListInfiniteQuery(
		ActivityKeys.infiniteList(
			filterDatefrom,
			filterDateto,
			filterOnlyunsolved,
			filterOnlysolved,
			filterSortdesc,
			pageSize,
		),
		(offset) =>
			getActivityV2(
				filterDatefrom,
				filterDateto,
				filterOnlyunsolved,
				filterOnlysolved,
				undefined,
				pageSize,
				offset,
				filterSortdesc,
			),
		{ pageSize },
	);
